
import React, { useState, useEffect } from 'react';
import { useAuth } from '../../../Common/Configurations/AuthContext';
import Header from '../../../Common/Layout/Header';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import countries from '../../../Data/Countries.json';
import moment from 'moment';
import config from '../../../Common/Configurations/APIConfig';
import apiService from "../../../Common/Configurations/APIService";
import DefaultData from '../../../CompanyData/DefaultData';
import './FlightDetails1.css';

const FlightDetails1 = () => {
    const params = useParams();
    const navigate = useNavigate();
    const { state } = useLocation();
    const { user, loading } = useAuth();
    const [minDate, setMinDate] = useState('');
    const [errors, setErrors] = useState({});
    const [passportErrors, setPassportErrors] = useState({});
    const [btnLoading, setBtnLoading] = useState(false);
    const [searchQuery, setSearchQuery] = useState({});
    const [itinerary, setItinerary] = useState([]);
    const [legs, setLegs] = useState([]);
    const [adultTravellers, setAdultTravellers] = useState([]);
    const [kidTravellers, setKidTravellers] = useState([]);
    const [infantTravellers, setInfantTravellers] = useState([]);
    const [totalTravellers, setTotalTravellers] = useState(0);
    const [discount, setDiscount] = useState(0);
    const [baseFare, setBaseFare] = useState(0);
    const [tax, setTax] = useState(0);
    const [totalFare, setTotalFare] = useState(0);
    const [totalPrice, setTotalPrice] = useState(0)
    const [convenienceFee, setConvenienceFee] = useState(0)
    const [email, setEmail] = useState(user?.email);
    const [mobile, setMobile] = useState(user?.phoneNumber);
    const [paymentGatewayFee, setPaymentGatewayFee] = useState(0);
    const [paymentGatewayAmount, setPaymentGatewayAmount] = useState(0);
    const [companyGST, setCompanyGST] = useState(user?.companygstno);
    const [companyName, setCompanyName] = useState(user?.companyname);
    const [companyAddress, setCompanyAddress] = useState(user?.companyaddress);
    const [bookingStatus, setBookingStatus] = useState('');
    
    // Modal states
    const [showBookingModal, setShowBookingModal] = useState(false);
    const [showFlightModal, setShowFlightModal] = useState(false);
    const [selectedFlightDetails, setSelectedFlightDetails] = useState(null);
    const [activeTab, setActiveTab] = useState({});

    const handleTabClick = (modalId, tabId) => {
        setActiveTab(prev => ({
            ...prev,
            [modalId]: tabId
        }));
    };

    const handleShowFlightDetails = (flightData, legData, idx, index) => {
        setSelectedFlightDetails({
            itinerary: flightData,
            leg: legData,
            modalId: `flight-${idx}-${index}`,
            idx: idx,
            index: index
        });
        setShowFlightModal(true);
    };

    function getformtravelData(tData) {
        var gender = "MALE";
        if (tData.title === "Mr") {
            gender = "MALE";
        }
        else if (tData.title === "Mrs") {
            gender = "FEMALE";
        }
        else if (tData.title === "Ms") {
            gender = "FEMALE";
        }
        else if (tData.title === "Master") {
            gender = "MALE";
        }
        const myObject = {
            travelerId: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
            firstName: tData.firstName,
            lastName: tData.lastName,
            title: tData.title,
            gender: gender,
            travelerType: tData.type,
            dateOfBirth: params.isDomestic === 'INTERNATIONAL' ? moment(tData.dateOfBirth).format('YYYY-MM-DD') : moment(new Date()).format('YYYY-MM-DD'),
            passportNo: tData.passportNo,
            passportNationality: tData.passportNationality,
            passbookIssueDate: params.isDomestic === 'INTERNATIONAL' ? moment(tData.passbookIssueDate).format('YYYY-MM-DD') : moment(new Date()).format('YYYY-MM-DD'),
            passbookExpireDate: params.isDomestic === 'INTERNATIONAL' ? moment(tData.passbookExpireDate).format('YYYY-MM-DD') : moment(new Date()).format('YYYY-MM-DD'),
        };
        return myObject;
    }

    const handleEmailChange = (e) => {
        setEmail(e.target.value)
    }

    const handleMobileChange = (e) => {
        setMobile(e.target.value)
    }

    const validate = (index, adata) => {
        let temp = {};
        temp.firstName = adata.firstName === "" ? false : true;
        temp.lastName = adata.lastName === "" ? false : true;
        if (params.isDomestic === 'INTERNATIONAL') {
            temp.dateOfBirth = adata.dateOfBirth === "" ? false : true;
            temp.passportNo = adata.passportNo === "" ? false : true;
            temp.passportNationality = adata.passportNationality === "" ? false : true;
            temp.passbookIssueDate = adata.passbookIssueDate === "" ? false : true;
            temp.passbookExpireDate = adata.passbookExpireDate === "" ? false : true;
        }
        temp.email = email === "" ? false : true;
        temp.mobile = mobile === "" ? false : true;
        setErrors(temp);
        return Object.values(temp).every((x) => x === true);
    };

    const [errorAdult, setAdultError] = useState('');
    const [errorKid, setKidError] = useState('');
    const [errorInfant, setInfantError] = useState('');

    const validateAdultDate = (index, event) => {
        const inputDate = new Date(event.target.value);
        const year = inputDate.getFullYear().toString();
        const currentYear = new Date().getFullYear();
        const minYear = currentYear - 100;
        if (year.length > 4 && event.target.value) {
            setAdultError('The year must be 4 digits!');
            event.target.value = ''; // Clear the input value
        }
        if (year < minYear || year > currentYear) {
            setAdultError(`The year must be between ${minYear} and ${currentYear}!`);
            event.target.setCustomValidity(`The year must be between ${minYear} and ${currentYear}`);
            event.target.value = ''; // Clear the input value
        }
        else {
            const values = [...adultTravellers];
            const updatedValue = event.target.name;
            values[index][updatedValue] = event.target.value;
            setAdultTravellers(values);
            setAdultError('');
        }
    };

    const validateKidsDate = (index, event) => {
        const inputDate = new Date(event.target.value);
        const year = inputDate.getFullYear().toString();
        const currentYear = new Date().getFullYear();
        const minYear = currentYear - 12;
        if (year.length > 4 && event.target.value) {
            setKidError('The year must be 4 digits!');
            event.target.value = ''; // Clear the input value
        }
        if (year < minYear || year > currentYear) {
            setKidError(`The year must be between ${minYear} and ${currentYear}!`);
            event.target.setCustomValidity(`The year must be between ${minYear} and ${currentYear}`);
            event.target.value = ''; // Clear the input value
        }
        else {
            const values = [...kidTravellers];
            const updatedValue = event.target.name;
            values[index][updatedValue] = event.target.value;
            setKidTravellers(values);
            setKidError('');
        }
    };

    const validateInfantDate = (index, event) => {
        const inputDate = new Date(event.target.value);
        const year = inputDate.getFullYear().toString();
        const currentYear = new Date().getFullYear();
        const minYear = currentYear - 2;
        if (year.length > 4 && event.target.value) {
            setInfantError('The year must be 4 digits!');
            event.target.value = ''; // Clear the input value
        }
        if (year < minYear || year > currentYear) {
            setInfantError(`The year must be between ${minYear} and ${currentYear}!`);
            event.target.setCustomValidity(`The year must be between ${minYear} and ${currentYear}`);
            event.target.value = ''; // Clear the input value
        }
        else {
            const values = [...infantTravellers];
            const updatedValue = event.target.name;
            values[index][updatedValue] = event.target.value;
            setInfantTravellers(values);
            setInfantError('');
        }
    };

    const handleAdultChange = (index, event) => {
        const values = [...adultTravellers];
        const updatedValue = event.target.name;
        values[index][updatedValue] = event.target.value;
        setAdultTravellers(values);
    };

    const handleKidsChange = (index, event) => {
        const values = [...kidTravellers];
        const updatedValue = event.target.name;
        values[index][updatedValue] = event.target.value;
        setKidTravellers(values);
    };

    const handleInfantChange = (index, event) => {
        const values = [...infantTravellers];
        const updatedValue = event.target.name;
        values[index][updatedValue] = event.target.value;
        setInfantTravellers(values);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setBtnLoading(true);
        var temptravellerinfos = [];
        for (var i = 0; i < adultTravellers.length; i++) {
            if (validate(i, adultTravellers[i])) {
                var tempData = getformtravelData(adultTravellers[i]);
                temptravellerinfos = [...temptravellerinfos, tempData];
            }
        }
        for (var i = 0; i < kidTravellers.length; i++) {
            if (validate(i, kidTravellers[i])) {
                var tempData = getformtravelData(kidTravellers[i]);
                temptravellerinfos = [...temptravellerinfos, tempData];
            }
        }
        for (var i = 0; i < infantTravellers.length; i++) {
            if (validate(i, infantTravellers[i])) {
                var tempData = getformtravelData(infantTravellers[i]);
                temptravellerinfos = [...temptravellerinfos, tempData];
            }
        }
        if (errorAdult !== "" || errorKid !== "" || errorInfant !== "") {
            alert("Please check the errors");
        }
        else if (temptravellerinfos.length === totalTravellers) {
            const flightBookingRequest = {
                flightBookingId: "00000000-0000-0000-0000-000000000000",
                userId: user?.id,
                branchId: user?.bid,
                bookingNo: '',
                pnr: '',
                isDomestic: params.isDomestic,
                isHold: false,
                supplierId: itinerary[0]?.fare?.supplierId,
                travellerInfos: [],
                dcFlightLegs: legs,
                dcPriceDetails: itinerary.flatMap(item => item.fare),
                flightSearchRequest: searchQuery,
                baseFare: baseFare,
                tax: tax,
                totalFare: totalFare,
                totalPrice: totalPrice,
                convenienceFee: convenienceFee,
                gst: 0,
                gstAmount: 0,
                discount: discount,
                markup: 0,
                couponCode: '',
                email: email,
                mobile: mobile,
                transactionNo: '',
                paymentGatewayNo: '',
                paymentGatewayFee: 0,
                paymentGateway: 'DIRECT',
                paymentStatus: 'PENDING',
                bookingStatus: bookingStatus,
                paymentGatewayAmount: paymentGatewayAmount,
                companyGST: companyGST === '' ? user?.companygstno : companyGST,
                companyName: companyName === '' ? user?.companyname : companyName,
                companyAddress: companyAddress,
                requestedBy: DefaultData.USERTYPE
            }
            flightBookingRequest.travellerInfos = temptravellerinfos;
            var flightBookingResponse = await apiService.post(config.REVIEWHFLIGHT, flightBookingRequest);
            console.log(flightBookingResponse);
            setBtnLoading(false);
            if (flightBookingResponse?.status === true) {
                navigate('/flight/review/' + params.adults + "/" + params.kids + "/" + params.infants + "/" + params.isDomestic, { state: { flightBookingResponse } });
            }
            else {
                alert(flightBookingResponse?.message === null ? "Request flight is not available. Try different flight" : flightBookingResponse?.message);
            }
        }
        else {
            setBtnLoading(false);
            alert("Please enter travelers data");
        }
    };

    const validatePassportDates = (travellerType, index, event) => {
        const { name, value } = event.target;
        const today = new Date();
        const inputDate = new Date(value);
        let values;

        if (travellerType === "adult") values = [...adultTravellers];
        if (travellerType === "kid") values = [...kidTravellers];
        if (travellerType === "infant") values = [...infantTravellers];

        let errors = { ...passportErrors };
        const errorKey = `${travellerType}_${index}_${name}`;

        if (name === "passbookIssueDate") {
            if (inputDate > today) {
                errors[errorKey] = "Passport issue date cannot be greater than today's date!";
                values[index][name] = "";
                setPassportErrors(errors);
                if (travellerType === "adult") setAdultTravellers(values);
                if (travellerType === "kid") setKidTravellers(values);
                if (travellerType === "infant") setInfantTravellers(values);
                return;
            } else {
                errors[errorKey] = "";
            }
        }

        if (name === "passbookExpireDate") {
            const minExpiry = new Date();
            minExpiry.setMonth(minExpiry.getMonth() + 6);

            if (inputDate <= minExpiry) {
                errors[errorKey] = "Passport expiry date must be at least 6 months from today!";
                values[index][name] = "";
                setPassportErrors(errors);
                if (travellerType === "adult") setAdultTravellers(values);
                if (travellerType === "kid") setKidTravellers(values);
                if (travellerType === "infant") setInfantTravellers(values);
                return;
            } else {
                errors[errorKey] = "";
            }
        }

        values[index][name] = value;
        if (travellerType === "adult") setAdultTravellers(values);
        if (travellerType === "kid") setKidTravellers(values);
        if (travellerType === "infant") setInfantTravellers(values);

        setPassportErrors(errors);
    };

    function getTimeFromMins(mins) {
        var h = mins / 60 | 0, m = mins % 60 | 0;
        var durationformat = h + "h " + m + "m";
        return durationformat;
    }

    const handleConfirmBooking = () => {
        setShowBookingModal(true);
    };

    const handleContinueBooking = () => {
        setShowBookingModal(false);
        handleSubmit(new Event('submit'));
    };



    const handleBack = () => {
        navigate(-1);
    };

    useEffect(() => {
        if (state === null) {
            navigate('/template/flight/search');
        }
        else if (params === null) {
            navigate('/template/flight/search');
        }
        else if (state.searchQuery === null) {
            navigate('/template/flight/search');
        }
        else {
            console.log(state);
            const today = new Date().toISOString().split('T')[0];
            setMinDate(today);
            setSearchQuery(state.searchQuery);
            setItinerary(state.payload);
            const itinerary = state.payload;
            setBaseFare(Object.values(itinerary).reduce((sum, sf) => sum + (sf.fare?.basePrice || 0), 0).toFixed(2));
            setTax(Object.values(itinerary).reduce((sum, sf) => sum + (sf.fare?.tax || 0), 0).toFixed(2));
            setTotalFare(Object.values(itinerary).reduce((sum, sf) => sum + (sf.fare?.totalFare || 0), 0).toFixed(2));
            setTotalPrice(Object.values(itinerary).reduce((sum, sf) => sum + (sf.fare?.totalPrice || 0), 0).toFixed(2));
            setConvenienceFee(Object.values(itinerary).reduce((sum, sf) => sum + (sf.fare?.convenienceFee || 0), 0).toFixed(2));
            setPaymentGatewayFee(Object.values(itinerary).reduce((sum, sf) => sum + (sf.fare?.paymentGatewayFee || 0), 0).toFixed(2));
            setPaymentGatewayAmount(Object.values(itinerary).reduce((sum, sf) => sum + (sf.fare?.paymentGatewayAmount || 0), 0).toFixed(2));
            setTotalTravellers(parseInt(params.adults) + parseInt(params.kids) + parseInt(params.infants))
            const filteredFlights = state.payload.map(item => {
                const { dcPriceDetails, ...rest } = item.flightLeg;
                return rest;
            });
            setLegs(filteredFlights);
            const avalues = [...adultTravellers];
            if (adultTravellers.length < params.adults) {
                for (var i = 0; i < params.adults; i++) {
                    avalues.push({ title: "Mr", firstName: "", lastName: "", type: "ADULT", dateOfBirth: "", passportNo: "", passportNationality: "IN", passbookIssueDate: "", passbookExpireDate: "" });
                    setAdultTravellers(avalues);
                }
            }
            const kvalues = [...kidTravellers];
            if (kidTravellers.length < params.kids) {
                for (var i = 0; i < params.kids; i++) {
                    kvalues.push({ title: "Master", firstName: "", lastName: "", type: "CHILD", dateOfBirth: "", passportNo: "", passportNationality: "IN", passbookIssueDate: "", passbookExpireDate: "" });
                    setKidTravellers(kvalues);
                }
            }
            const ivalues = [...infantTravellers];
            if (infantTravellers.length < params.infants) {
                for (var i = 0; i < params.infants; i++) {
                    ivalues.push({ title: "Master", firstName: "", lastName: "", type: "INFANT", dateOfBirth: "", passportNo: "", passportNationality: "IN", passbookIssueDate: "", passbookExpireDate: "" });
                    setInfantTravellers(ivalues);
                }
            }
        }
    }, [user, loading]);

    if (loading) return <p>Loading...</p>;
    if (!user) { navigate("/") };
    
    return (
        <div id="layout-wrapper">
            <Header User={user} activeSection="flights" />
            <div className="main-content">
                <div className="page-content">
                    <div className="container-fluid">
                        <div className="fd1-application-card">
                           

                            {/* TWO COLUMN LAYOUT */}
                            <div className="fd1-two-column">
                                {/* LEFT COLUMN: Flight Details & Traveler Forms */}
                                <div className="fd1-left-form">
                                    <div className="fd1-section-title-left">
                                        <i className="fas fa-clipboard-check"></i> Confirm Flight Details
                                    </div>

                                    {/* Flight Cards */}
                                    {itinerary.length > 0 && itinerary.map((it, idx) => (
                                        it.flightLeg?.dcDisplayLegs?.length > 0 && it.flightLeg.dcDisplayLegs.map((leg, index) => {
                                            return (
                                                <div className="fd1-flight-card" key={`${idx}-${index}`}>
                                                    <div className="fd1-flight-card-header">
                                                        <div className="fd1-route-title">
                                                            <h5>{leg.startSegment.city}, {leg.startSegment.airportCode}</h5>
                                                            <span className="fd1-route-arrow">➝</span>
                                                            <h5>{leg.endSegment.city}, {leg.endSegment.airportCode}</h5>
                                                            <span className="fd1-date-badge">
                                                                <i className="fas fa-calendar"></i> {moment(leg.startSegment.departureDateTime).format('DD MMM YY')}
                                                            </span>
                                                        </div>
                                                        <div>
                                                            <span className={`fd1-refund-badge ${it.flightLeg?.refundable === "Refundable" ? "success" : "danger"}`}>
                                                                <i className={`fas fa-${it.flightLeg?.refundable === "Refundable" ? "check-circle" : "times-circle"}`}></i> {it.flightLeg?.refundable}
                                                            </span>
                                                            <button 
                                                                className="fd1-details-link ms-3" 
                                                                onClick={() => handleShowFlightDetails(it, leg, idx, index)}
                                                                style={{ background: 'none', border: 'none' }}
                                                            >
                                                                Details
                                                            </button>
                                                        </div>
                                                    </div>
                                                    <div className="fd1-flight-card-body">
                                                        <div className="fd1-flight-row">
                                                            <div className="fd1-airline-info">
                                                                <div className="fd1-airline-logo">
                                                                    <img 
                                                                        src={`/assets/images/airlinelogos/${leg.airlineData.airlineCode}.png`} 
                                                                        alt={leg.airlineData.airlineCode}
                                                                        style={{ width: '30px', height: '30px', objectFit: 'contain' }}
                                                                        onError={(e) => {
                                                                            e.target.onerror = null;
                                                                            e.target.style.display = 'none';
                                                                            e.target.parentNode.innerHTML = '<i className="fas fa-building"></i>';
                                                                        }}
                                                                    />
                                                                </div>
                                                                <div className="fd1-airline-details">
                                                                    <h6>{leg?.airlineData?.airline}</h6>
                                                                    <small>{leg?.airlineData?.airlineCode}-{leg?.airlineData?.flightNumber}</small>
                                                                </div>
                                                            </div>

                                                            <div className="fd1-time-info">
                                                                <div className="fd1-time">{moment(leg?.startSegment?.departureDateTime).format("HH:mm")}</div>
                                                                <div className="fd1-date">{moment(leg?.startSegment?.departureDateTime).format("DD MMM YY")}</div>
                                                                <div className="fd1-place">{leg?.startSegment?.airportCode}</div>
                                                            </div>

                                                            <div className="fd1-duration-info">
                                                                <div className="fd1-duration-badge">{getTimeFromMins(leg?.totalDuration)}</div>
                                                                <div className="fd1-stop-info">{leg?.stops === 0 ? "Non Stop" : leg?.stops === 1 ? "1 Stop" : leg?.stops + " Stops"}</div>
                                                            </div>

                                                            <div className="fd1-time-info">
                                                                <div className="fd1-time">{moment(leg?.endSegment?.arrivalDateTime).format("HH:mm")}</div>
                                                                <div className="fd1-date">{moment(leg?.endSegment?.arrivalDateTime).format("DD MMM YY")}</div>
                                                                <div className="fd1-place">{leg?.endSegment?.airportCode}</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            );
                                        })
                                    ))}

                                    {/* Note Alert */}
                                    <div className="fd1-alert-info-custom">
                                        <span className="fd1-badge">NOTE:</span> This is a special fare given by the airline. Airlines cancellation charges do apply.
                                    </div>

                                    {/* Traveler Details Section */}
                                    <div className="fd1-traveler-section">
                                        <div className="fd1-section-header-custom">
                                            <i className="fas fa-users"></i>
                                            <h6>Traveler Details</h6>
                                        </div>

                                        <div className="fd1-info-banner">
                                            <span className="fd1-badge">New</span>
                                            <span>Please enter your name as per your passport or pancard</span>
                                        </div>

                                        {/* Adults */}
                                        {adultTravellers.length > 0 && (
                                            <div className="fd1-passenger-category">
                                                <div className="fd1-category-title">
                                                    <i className="fas fa-user-tie"></i> Adults ({adultTravellers.length})
                                                </div>
                                                <div className="fd1-passenger-grid">
                                                    {adultTravellers.map((adult, index) => (
                                                        <div className="fd1-passenger-card" key={`adult-${index}`}>
                                                            <h5>Adult {index + 1}</h5>
                                                            <div className="fd1-passenger-fields">
                                                                <div className="fd1-field-group">
                                                                    <label><i className="fas fa-user"></i> Title</label>
                                                                    <select 
                                                                        name="title" 
                                                                        value={adult.title} 
                                                                        onChange={(event) => handleAdultChange(index, event)}
                                                                    >
                                                                        <option value="Mr">Mr</option>
                                                                        <option value="Mrs">Mrs</option>
                                                                        <option value="Ms">Ms</option>
                                                                        <option value="Master">Master</option>
                                                                    </select>
                                                                    {errors.title === false && (<div className="fd1-validationerror">Please select title</div>)}
                                                                </div>
                                                                <div className="fd1-field-group">
                                                                    <label><i className="fas fa-signature"></i> Given Name</label>
                                                                    <input 
                                                                        type="text" 
                                                                        name="firstName" 
                                                                        value={adult.firstName} 
                                                                        onChange={(event) => handleAdultChange(index, event)} 
                                                                        placeholder="First Name" 
                                                                    />
                                                                    {errors.firstName === false && (<div className="fd1-validationerror">Please enter first name</div>)}
                                                                </div>
                                                                <div className="fd1-field-group">
                                                                    <label><i className="fas fa-signature"></i> Surname</label>
                                                                    <input 
                                                                        type="text" 
                                                                        name="lastName" 
                                                                        value={adult.lastName} 
                                                                        onChange={(event) => handleAdultChange(index, event)} 
                                                                        placeholder="Last Name" 
                                                                    />
                                                                    {errors.lastName === false && (<div className="fd1-validationerror">Please enter last name</div>)}
                                                                </div>
                                                                {params.isDomestic === 'INTERNATIONAL' && (
                                                                    <div className="fd1-field-group">
                                                                        <label><i className="fas fa-calendar"></i> Date of Birth</label>
                                                                        <input 
                                                                            type="date" 
                                                                            name="dateOfBirth" 
                                                                            value={adult.dateOfBirth} 
                                                                            onBlur={(event) => validateAdultDate(index, event)} 
                                                                            onChange={(event) => handleAdultChange(index, event)} 
                                                                        />
                                                                        {errors.dateOfBirth === false && (<div className="fd1-validationerror">Please enter date of birth</div>)}
                                                                        {errorAdult && <div className="fd1-validationerror">{errorAdult}</div>}
                                                                    </div>
                                                                )}
                                                            </div>
                                                            
                                                            {params.isDomestic === 'INTERNATIONAL' && (
                                                                <div className="fd1-passenger-fields mt-2">
                                                                    <div className="fd1-field-group">
                                                                        <label><i className="fas fa-passport"></i> Passport No</label>
                                                                        <input 
                                                                            type="text" 
                                                                            name="passportNo" 
                                                                            value={adult.passportNo} 
                                                                            onChange={(event) => handleAdultChange(index, event)} 
                                                                            maxLength="10" 
                                                                            placeholder="Passport No" 
                                                                        />
                                                                        {errors.passportNo === false && (<div className="fd1-validationerror">Please enter passport no</div>)}
                                                                    </div>
                                                                    <div className="fd1-field-group">
                                                                        <label><i className="fas fa-globe"></i> Nationality</label>
                                                                        <select 
                                                                            name="passportNationality" 
                                                                            value={adult.passportNationality} 
                                                                            onChange={(event) => handleAdultChange(index, event)}
                                                                        >
                                                                            {countries.length > 0 && countries.map(cs => (
                                                                                <option key={cs.code} value={cs.code}>{cs.name}</option>
                                                                            ))}
                                                                        </select>
                                                                        {errors.passportNationality === false && (<div className="fd1-validationerror">Please select nationality</div>)}
                                                                    </div>
                                                                    <div className="fd1-field-group">
                                                                        <label><i className="fas fa-calendar-plus"></i> Issue Date</label>
                                                                        <input 
                                                                            type="date" 
                                                                            name="passbookIssueDate" 
                                                                            value={adult.passbookIssueDate} 
                                                                            onChange={(event) => handleAdultChange(index, event)} 
                                                                            onBlur={(event) => validatePassportDates("adult", index, event)} 
                                                                        />
                                                                        {errors.passbookIssueDate === false && (<div className="fd1-validationerror">Please enter issue date</div>)}
                                                                        {passportErrors[`adult_${index}_passbookIssueDate`] && (<div className="fd1-validationerror">{passportErrors[`adult_${index}_passbookIssueDate`]}</div>)}
                                                                    </div>
                                                                    <div className="fd1-field-group">
                                                                        <label><i className="fas fa-calendar-times"></i> Expiry Date</label>
                                                                        <input 
                                                                            type="date" 
                                                                            name="passbookExpireDate" 
                                                                            value={adult.passbookExpireDate} 
                                                                            onChange={(event) => handleAdultChange(index, event)} 
                                                                            onBlur={(event) => validatePassportDates("adult", index, event)} 
                                                                            min={minDate}
                                                                        />
                                                                        {errors.passbookExpireDate === false && (<div className="fd1-validationerror">Please enter expiry date</div>)}
                                                                        {passportErrors[`adult_${index}_passbookExpireDate`] && (<div className="fd1-validationerror">{passportErrors[`adult_${index}_passbookExpireDate`]}</div>)}
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        )}

                                        {/* Children */}
                                        {kidTravellers.length > 0 && (
                                            <div className="fd1-passenger-category">
                                                <div className="fd1-category-title">
                                                    <i className="fas fa-child"></i> Children ({kidTravellers.length})
                                                </div>
                                                <div className="fd1-passenger-grid">
                                                    {kidTravellers.map((kid, index) => (
                                                        <div className="fd1-passenger-card" key={`kid-${index}`}>
                                                            <h5>Child {index + 1}</h5>
                                                            <div className="fd1-passenger-fields">
                                                                <div className="fd1-field-group">
                                                                    <label><i className="fas fa-user"></i> Title</label>
                                                                    <select 
                                                                        name="title" 
                                                                        value={kid.title} 
                                                                        onChange={(event) => handleKidsChange(index, event)}
                                                                    >
                                                                        <option value="Ms">Ms</option>
                                                                        <option value="Master">Master</option>
                                                                    </select>
                                                                    {errors.title === false && (<div className="fd1-validationerror">Please select title</div>)}
                                                                </div>
                                                                <div className="fd1-field-group">
                                                                    <label><i className="fas fa-signature"></i> Given Name</label>
                                                                    <input 
                                                                        type="text" 
                                                                        name="firstName" 
                                                                        value={kid.firstName} 
                                                                        onChange={(event) => handleKidsChange(index, event)} 
                                                                        placeholder="First Name" 
                                                                    />
                                                                    {errors.firstName === false && (<div className="fd1-validationerror">Please enter first name</div>)}
                                                                </div>
                                                                <div className="fd1-field-group">
                                                                    <label><i className="fas fa-signature"></i> Surname</label>
                                                                    <input 
                                                                        type="text" 
                                                                        name="lastName" 
                                                                        value={kid.lastName} 
                                                                        onChange={(event) => handleKidsChange(index, event)} 
                                                                        placeholder="Last Name" 
                                                                    />
                                                                    {errors.lastName === false && (<div className="fd1-validationerror">Please enter last name</div>)}
                                                                </div>
                                                                {params.isDomestic === 'INTERNATIONAL' && (
                                                                    <div className="fd1-field-group">
                                                                        <label><i className="fas fa-calendar"></i> Date of Birth</label>
                                                                        <input 
                                                                            type="date" 
                                                                            name="dateOfBirth" 
                                                                            value={kid.dateOfBirth} 
                                                                            onBlur={(event) => validateKidsDate(index, event)} 
                                                                            onChange={(event) => handleKidsChange(index, event)} 
                                                                        />
                                                                        {errors.dateOfBirth === false && (<div className="fd1-validationerror">Please enter date of birth</div>)}
                                                                        {errorKid && <div className="fd1-validationerror">{errorKid}</div>}
                                                                    </div>
                                                                )}
                                                            </div>
                                                            
                                                            {params.isDomestic === 'INTERNATIONAL' && (
                                                                <div className="fd1-passenger-fields mt-2">
                                                                    <div className="fd1-field-group">
                                                                        <label><i className="fas fa-passport"></i> Passport No</label>
                                                                        <input 
                                                                            type="text" 
                                                                            name="passportNo" 
                                                                            value={kid.passportNo} 
                                                                            onChange={(event) => handleKidsChange(index, event)} 
                                                                            maxLength="10" 
                                                                            placeholder="Passport No" 
                                                                        />
                                                                        {errors.passportNo === false && (<div className="fd1-validationerror">Please enter passport no</div>)}
                                                                    </div>
                                                                    <div className="fd1-field-group">
                                                                        <label><i className="fas fa-globe"></i> Nationality</label>
                                                                        <select 
                                                                            name="passportNationality" 
                                                                            value={kid.passportNationality} 
                                                                            onChange={(event) => handleKidsChange(index, event)}
                                                                        >
                                                                            {countries.length > 0 && countries.map(cs => (
                                                                                <option key={cs.code} value={cs.code}>{cs.name}</option>
                                                                            ))}
                                                                        </select>
                                                                        {errors.passportNationality === false && (<div className="fd1-validationerror">Please select nationality</div>)}
                                                                    </div>
                                                                    <div className="fd1-field-group">
                                                                        <label><i className="fas fa-calendar-plus"></i> Issue Date</label>
                                                                        <input 
                                                                            type="date" 
                                                                            name="passbookIssueDate" 
                                                                            value={kid.passbookIssueDate} 
                                                                            onChange={(event) => handleKidsChange(index, event)} 
                                                                            onBlur={(event) => validatePassportDates("kid", index, event)} 
                                                                        />
                                                                        {errors.passbookIssueDate === false && (<div className="fd1-validationerror">Please enter issue date</div>)}
                                                                        {passportErrors[`kid_${index}_passbookIssueDate`] && (<div className="fd1-validationerror">{passportErrors[`kid_${index}_passbookIssueDate`]}</div>)}
                                                                    </div>
                                                                    <div className="fd1-field-group">
                                                                        <label><i className="fas fa-calendar-times"></i> Expiry Date</label>
                                                                        <input 
                                                                            type="date" 
                                                                            name="passbookExpireDate" 
                                                                            value={kid.passbookExpireDate} 
                                                                            onChange={(event) => handleKidsChange(index, event)} 
                                                                            onBlur={(event) => validatePassportDates("kid", index, event)} 
                                                                            min={minDate}
                                                                        />
                                                                        {errors.passbookExpireDate === false && (<div className="fd1-validationerror">Please enter expiry date</div>)}
                                                                        {passportErrors[`kid_${index}_passbookExpireDate`] && (<div className="fd1-validationerror">{passportErrors[`kid_${index}_passbookExpireDate`]}</div>)}
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        )}

                                        {/* Infants */}
                                        {infantTravellers.length > 0 && (
                                            <div className="fd1-passenger-category">
                                                <div className="fd1-category-title">
                                                    <i className="fas fa-baby"></i> Infants ({infantTravellers.length})
                                                </div>
                                                <div className="fd1-passenger-grid">
                                                    {infantTravellers.map((infant, index) => (
                                                        <div className="fd1-passenger-card" key={`infant-${index}`}>
                                                            <h5>Infant {index + 1}</h5>
                                                            <div className="fd1-passenger-fields">
                                                                <div className="fd1-field-group">
                                                                    <label><i className="fas fa-user"></i> Title</label>
                                                                    <select 
                                                                        name="title" 
                                                                        value={infant.title} 
                                                                        onChange={(event) => handleInfantChange(index, event)}
                                                                    >
                                                                        <option value="Ms">Ms</option>
                                                                        <option value="Master">Master</option>
                                                                    </select>
                                                                    {errors.title === false && (<div className="fd1-validationerror">Please select title</div>)}
                                                                </div>
                                                                <div className="fd1-field-group">
                                                                    <label><i className="fas fa-signature"></i> Given Name</label>
                                                                    <input 
                                                                        type="text" 
                                                                        name="firstName" 
                                                                        value={infant.firstName} 
                                                                        onChange={(event) => handleInfantChange(index, event)} 
                                                                        placeholder="First Name" 
                                                                    />
                                                                    {errors.firstName === false && (<div className="fd1-validationerror">Please enter first name</div>)}
                                                                </div>
                                                                <div className="fd1-field-group">
                                                                    <label><i className="fas fa-signature"></i> Surname</label>
                                                                    <input 
                                                                        type="text" 
                                                                        name="lastName" 
                                                                        value={infant.lastName} 
                                                                        onChange={(event) => handleInfantChange(index, event)} 
                                                                        placeholder="Last Name" 
                                                                    />
                                                                    {errors.lastName === false && (<div className="fd1-validationerror">Please enter last name</div>)}
                                                                </div>
                                                                {params.isDomestic === 'INTERNATIONAL' && (
                                                                    <div className="fd1-field-group">
                                                                        <label><i className="fas fa-calendar"></i> Date of Birth</label>
                                                                        <input 
                                                                            type="date" 
                                                                            name="dateOfBirth" 
                                                                            value={infant.dateOfBirth} 
                                                                            onBlur={(event) => validateInfantDate(index, event)} 
                                                                            onChange={(event) => handleInfantChange(index, event)} 
                                                                        />
                                                                        {errors.dateOfBirth === false && (<div className="fd1-validationerror">Please enter date of birth</div>)}
                                                                        {errorInfant && <div className="fd1-validationerror">{errorInfant}</div>}
                                                                    </div>
                                                                )}
                                                            </div>
                                                            
                                                            {params.isDomestic === 'INTERNATIONAL' && (
                                                                <div className="fd1-passenger-fields mt-2">
                                                                    <div className="fd1-field-group">
                                                                        <label><i className="fas fa-passport"></i> Passport No</label>
                                                                        <input 
                                                                            type="text" 
                                                                            name="passportNo" 
                                                                            value={infant.passportNo} 
                                                                            onChange={(event) => handleInfantChange(index, event)} 
                                                                            maxLength="10" 
                                                                            placeholder="Passport No" 
                                                                        />
                                                                        {errors.passportNo === false && (<div className="fd1-validationerror">Please enter passport no</div>)}
                                                                    </div>
                                                                    <div className="fd1-field-group">
                                                                        <label><i className="fas fa-globe"></i> Nationality</label>
                                                                        <select 
                                                                            name="passportNationality" 
                                                                            value={infant.passportNationality} 
                                                                            onChange={(event) => handleInfantChange(index, event)}
                                                                        >
                                                                            {countries.length > 0 && countries.map(cs => (
                                                                                <option key={cs.code} value={cs.code}>{cs.name}</option>
                                                                            ))}
                                                                        </select>
                                                                        {errors.passportNationality === false && (<div className="fd1-validationerror">Please select nationality</div>)}
                                                                    </div>
                                                                    <div className="fd1-field-group">
                                                                        <label><i className="fas fa-calendar-plus"></i> Issue Date</label>
                                                                        <input 
                                                                            type="date" 
                                                                            name="passbookIssueDate" 
                                                                            value={infant.passbookIssueDate} 
                                                                            onChange={(event) => handleInfantChange(index, event)} 
                                                                            onBlur={(event) => validatePassportDates("infant", index, event)} 
                                                                        />
                                                                        {errors.passbookIssueDate === false && (<div className="fd1-validationerror">Please enter issue date</div>)}
                                                                        {passportErrors[`infant_${index}_passbookIssueDate`] && (<div className="fd1-validationerror">{passportErrors[`infant_${index}_passbookIssueDate`]}</div>)}
                                                                    </div>
                                                                    <div className="fd1-field-group">
                                                                        <label><i className="fas fa-calendar-times"></i> Expiry Date</label>
                                                                        <input 
                                                                            type="date" 
                                                                            name="passbookExpireDate" 
                                                                            value={infant.passbookExpireDate} 
                                                                            onChange={(event) => handleInfantChange(index, event)} 
                                                                            onBlur={(event) => validatePassportDates("infant", index, event)} 
                                                                            min={minDate}
                                                                        />
                                                                        {errors.passbookExpireDate === false && (<div className="fd1-validationerror">Please enter expiry date</div>)}
                                                                        {passportErrors[`infant_${index}_passbookExpireDate`] && (<div className="fd1-validationerror">{passportErrors[`infant_${index}_passbookExpireDate`]}</div>)}
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        )}

                                        {/* Contact Information */}
                                        <div className="fd1-contact-block">
                                            <div className="fd1-field-group">
                                                <label><i className="fas fa-envelope"></i> Email Address</label>
                                                <input 
                                                    type="email" 
                                                    value={email} 
                                                    onChange={handleEmailChange} 
                                                    placeholder="Email" 
                                                />
                                                {errors.email === false && (<div className="fd1-validationerror">Please enter email</div>)}
                                            </div>
                                            <div className="fd1-field-group">
                                                <label><i className="fas fa-phone-alt"></i> Mobile Number</label>
                                                <input 
                                                    type="tel" 
                                                    value={mobile} 
                                                    onChange={handleMobileChange} 
                                                    placeholder="Mobile" 
                                                />
                                                {errors.mobile === false && (<div className="fd1-validationerror">Please enter mobile</div>)}
                                            </div>
                                        </div>

                                        {/* GST Information */}
                                        <div className="fd1-gst-section">
                                            <h6><i className="fas fa-file-invoice"></i> GST Information (optional)</h6>
                                            <div className="fd1-gst-row">
                                                <div className="fd1-field-group">
                                                    <label>GST Number</label>
                                                    <input 
                                                        type="text" 
                                                        value={companyGST} 
                                                        onChange={(e) => setCompanyGST(e.target.value)} 
                                                        placeholder="GST Number" 
                                                        maxLength="25" 
                                                    />
                                                </div>
                                                <div className="fd1-field-group">
                                                    <label>Registered Company Name</label>
                                                    <input 
                                                        type="text" 
                                                        value={companyName} 
                                                        onChange={(e) => setCompanyName(e.target.value)} 
                                                        placeholder="Company Name" 
                                                        maxLength="100" 
                                                    />
                                                </div>
                                                <div className="fd1-field-group">
                                                    <label>Company Address</label>
                                                    <input 
                                                        type="text" 
                                                        value={companyAddress} 
                                                        onChange={(e) => setCompanyAddress(e.target.value)} 
                                                        placeholder="Company Address" 
                                                    />
                                                </div>
                                            </div>
                                        </div>

                                        {/* Action Buttons */}
                                        <div className="fd1-action-buttons">
                                            <button className="fd1-btn-secondary" onClick={handleBack}>Back</button>
                                            <button 
                                                className="fd1-btn-primary" 
                                                onClick={handleConfirmBooking}
                                                disabled={btnLoading}
                                            >
                                                {btnLoading ? 'Processing...' : 'Confirm Booking'}
                                            </button>
                                        </div>
                                    </div>
                                </div>

                                {/* RIGHT COLUMN: Fare Details */}
                                <div className="fd1-right-fare">
                                    <div className="fd1-fare-panel">
                                        <h3><i className="fas fa-receipt"></i> Fare Details</h3>

                                        {/* Fare Breakdown */}
                                        <div className="fd1-fare-card-large">
                                            <div className="fd1-fare-row">
                                                <span className="fd1-fare-label"><i className="fas fa-tag"></i> Base Fare</span>
                                                <span className="fd1-fare-amount">INR{baseFare}</span>
                                            </div>
                                            <div className="fd1-fare-row">
                                                <span className="fd1-fare-label"><i className="fas fa-percent"></i> Taxes & Fees</span>
                                                <span className="fd1-fare-amount">INR{(parseFloat(tax) + parseFloat(convenienceFee) + parseFloat(paymentGatewayAmount)).toFixed(2)}</span>
                                            </div>
                                            <div className="fd1-fare-total">
                                                <span>Total Amount</span>
                                                <span>INR{totalPrice}</span>
                                            </div>
                                        </div>

                                        {/* Passenger Count Info */}
                                        <div className="fd1-passenger-count-info">
                                            <i className="fas fa-users me-2" style={{ color: '#fbbf24' }}></i>
                                            Adult : {params.adults}, Child : {params.kids}, Infant : {params.infants}
                                        </div>

                                        {/* Fare Rules Note */}
                                        <p className="fd1-fare-note">
                                            <i className="fas fa-info-circle"></i> Cancellation charges apply as per airline policy
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Flight Details Modal */}
            {showFlightModal && selectedFlightDetails && (
                <div className="fd1-modal-overlay" onClick={() => setShowFlightModal(false)}>
                    <div className="fd1-modal-content fd1-modal-lg" onClick={(e) => e.stopPropagation()}>
                        <div className="fd1-modal-header">
                            <h5 className="fd1-modal-title">
                                Flight Details - {selectedFlightDetails.leg.airlineData.flightNumber} · {selectedFlightDetails.leg.airlineData.airline}
                            </h5>
                            <button className="fd1-modal-close" onClick={() => setShowFlightModal(false)}>&times;</button>
                        </div>
                        <div className="fd1-modal-body">
                            <div className="fd1-custom-tabs">
                                <button 
                                    className={`fd1-custom-tab ${activeTab[selectedFlightDetails.modalId] === 'flight' || !activeTab[selectedFlightDetails.modalId] ? 'active' : ''}`}
                                    onClick={() => handleTabClick(selectedFlightDetails.modalId, 'flight')}
                                >
                                    Flight Details
                                </button>
                                <button 
                                    className={`fd1-custom-tab ${activeTab[selectedFlightDetails.modalId] === 'baggage' ? 'active' : ''}`}
                                    onClick={() => handleTabClick(selectedFlightDetails.modalId, 'baggage')}
                                >
                                    Baggage Details
                                </button>
                                <button 
                                    className={`fd1-custom-tab ${activeTab[selectedFlightDetails.modalId] === 'cancel' ? 'active' : ''}`}
                                    onClick={() => handleTabClick(selectedFlightDetails.modalId, 'cancel')}
                                >
                                    Cancellation Fee
                                </button>
                            </div>

                            <div className="fd1-custom-tab-content">
                                {(!activeTab[selectedFlightDetails.modalId] || activeTab[selectedFlightDetails.modalId] === 'flight') && (
                                    <div>
                                        {selectedFlightDetails.itinerary.flightLeg?.dcSegments?.map((seg, segIdx) => (
                                            <React.Fragment key={segIdx}>
                                                <div className="fd1-segment-row">
                                                    <div className="fd1-airline-info" style={{ minWidth: '180px' }}>
                                                        <div className="fd1-airline-logo" style={{ width: '35px', height: '35px' }}>
                                                            <img 
                                                                src={`/assets/images/airlinelogos/${seg.tFAirlineData?.airlineCode}.png`} 
                                                                alt={seg.tFAirlineData?.airlineCode}
                                                                style={{ width: '25px', height: '25px', objectFit: 'contain' }}
                                                                onError={(e) => {
                                                                    e.target.onerror = null;
                                                                    e.target.style.display = 'none';
                                                                    e.target.parentNode.innerHTML = '<i className="fas fa-building"></i>';
                                                                }}
                                                            />
                                                        </div>
                                                        <div>
                                                            <strong>{seg.tFAirlineData?.airline}</strong>
                                                            <div><small>{seg.tFAirlineData?.flightNumber}</small></div>
                                                        </div>
                                                    </div>
                                                    <div className="fd1-time-info">
                                                        <div className="fw-bold">{moment(seg.tFDepartureData.departureDateTime).format('HH:mm')}</div>
                                                        <small>{seg.tFDepartureData.airportCode} · {seg.tFDepartureData.terminal && `Terminal ${seg.tFDepartureData.terminal}`}</small>
                                                    </div>
                                                    <div><i className="fas fa-arrow-right"></i></div>
                                                    <div className="fd1-time-info">
                                                        <div className="fw-bold">{moment(seg.tFArrivalData.arrivalDateTime).format('HH:mm')}</div>
                                                        <small>{seg.tFArrivalData.airportCode} · {seg.tFArrivalData.terminal && `Terminal ${seg.tFArrivalData.terminal}`}</small>
                                                    </div>
                                                    <div className="fd1-duration-info">
                                                        <span className="fd1-badge-warning">{getTimeFromMins(seg.tFAirlineData?.duration)}</span>
                                                    </div>
                                                </div>
                                                {seg.tFAirlineData?.connectingTime !== 0 && segIdx < selectedFlightDetails.itinerary.flightLeg.dcSegments.length - 1 && (
                                                    <div className="fd1-connecting-badge">
                                                        <i className="fas fa-clock"></i> Layover: {getTimeFromMins(seg.tFAirlineData?.connectingTime)}
                                                    </div>
                                                )}
                                            </React.Fragment>
                                        ))}
                                    </div>
                                )}

                                {activeTab[selectedFlightDetails.modalId] === 'baggage' && (
                                    <div>
                                        <table className="fd1-baggage-table">
                                            <thead>
                                                <tr>
                                                    <th></th>
                                                    <th>Cabin</th>
                                                    <th>Check-In</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>Adult</td>
                                                    <td>{selectedFlightDetails.itinerary.flightLeg?.dcPriceDetails[0]?.dcAdults?.cabinBag || '7 Kg'}</td>
                                                    <td>{selectedFlightDetails.itinerary.flightLeg?.dcPriceDetails[0]?.dcAdults?.checkinBag || '20 Kg'}</td>
                                                </tr>
                                                <tr>
                                                    <td>Child</td>
                                                    <td>{selectedFlightDetails.itinerary.flightLeg?.dcPriceDetails[0]?.dcKids?.cabinBag || '7 Kg'}</td>
                                                    <td>{selectedFlightDetails.itinerary.flightLeg?.dcPriceDetails[0]?.dcKids?.checkinBag || '20 Kg'}</td>
                                                </tr>
                                                <tr>
                                                    <td>Infant</td>
                                                    <td>{selectedFlightDetails.itinerary.flightLeg?.dcPriceDetails[0]?.dcInfants?.cabinBag || '0 Kg'}</td>
                                                    <td>{selectedFlightDetails.itinerary.flightLeg?.dcPriceDetails[0]?.dcInfants?.checkinBag || '0 Kg'}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                )}

                                {activeTab[selectedFlightDetails.modalId] === 'cancel' && (
                                    <div>
                                        <ul style={{ fontSize: '0.85rem', paddingLeft: '20px' }}>
                                            <li>The penalty is subject before departure. No Changes are allowed after that.</li>
                                            <li>The charges are per passenger per sector.</li>
                                            <li>Partial cancellation is not allowed on tickets booked under special discounted fares.</li>
                                            <li>In case of no-show or ticket not cancelled within the stipulated time, only statutory taxes are refundable subject to Service Fee.</li>
                                            <li>No Baggage Allowance for Infants</li>
                                            <li>Airline penalty needs to be reconfirmed prior to any amendments or cancellation.</li>
                                        </ul>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Booking Confirmation Modal */}
            {showBookingModal && (
                <div className="fd1-modal-overlay" onClick={() => setShowBookingModal(false)}>
                    <div className="fd1-modal-content" onClick={(e) => e.stopPropagation()}>
                        <div className="fd1-modal-header">
                            <h5 className="fd1-modal-title">Confirm Booking</h5>
                            <button className="fd1-modal-close" onClick={() => setShowBookingModal(false)}>&times;</button>
                        </div>
                        <div className="fd1-modal-body">
                            <div className="fd1-selected-flight-summary">
                                <p><strong>Flight:</strong> {itinerary.map((it, idx) => (
                                    <span key={idx}>
                                        {it.flightLeg?.dcDisplayLegs[0]?.airlineData?.flightNumber} 
                                        {idx < itinerary.length - 1 ? ' & ' : ''}
                                    </span>
                                ))}</p>
                                <p><strong>Passengers:</strong> {params.adults} Adult{params.adults > 1 ? 's' : ''}, {params.kids} Child{params.kids > 1 ? 'ren' : ''}, {params.infants} Infant{params.infants > 1 ? 's' : ''}</p>
                                <p><strong>Total Amount:</strong> INR{totalPrice}</p>
                            </div>
                           
                            <div className="fd1-booking-options">
                                <button className="fd1-booking-option-btn fd1-booking-option-primary" onClick={handleContinueBooking}>Continue Booking</button>
                                                      </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default FlightDetails1;